import React, { useState } from 'react';
import axios from 'axios';
import target from "../images/target.png"

const QuickPayment = ({ theme, userEmail, userName, typeOfMembership, amount, lateFee, daysLeft, expired, expirationDate, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const isDark = theme

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Helper to get raw days for the UI and logic
    const getDaysPast = () => {
        if (!expirationDate) return 0;
        const exp = new Date(expirationDate);
        const today = new Date();
        exp.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        const diffInTime = today.getTime() - exp.getTime();
        return Math.floor(diffInTime / (1000 * 3600 * 24));
    };

    const daysPast = getDaysPast();
    const effectiveLateFee = daysPast > 90 ? parseFloat(lateFee) : 0;

    let amt = parseFloat(amount);
    let totalx = parseInt(amt * 100);
    if (effectiveLateFee > 0) {
        totalx = parseInt(amt * 100) + parseInt(effectiveLateFee * 100);
    }

    const finalTotal = Math.round(totalx) / 100;

    const handlePayment = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post(
                'https://us-central1-abqpressclub.cloudfunctions.net/createStripeSession',
                {
                    email: userEmail,
                    amount: parseInt(finalTotal * 100),
                    productName: `Albuquerque Press Club Membership Renewal: ${typeOfMembership}`
                }
            );

            if (response.data?.url) {
                window.location.href = response.data.url;
            }
        } catch (err) {
            setError(`Connection failed: ${err.response?.data?.error || err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={theme === 'dark' ? " white" : ""} style={{ 'background': 'none', 'borderRadius': '6px' }}>
            <div className="flex justify-between items-center text-center p-6 padding">
                <h2 className="apc padding animated fadeInRight modified-apc">APC </h2>
                <h4 className=" animated fadeInLeft">Membership</h4>

                <div className=" flex justify-between items-center">
                    <span className="text-sm font-bold text-primary">Days Remaining:&nbsp;</span>
                    <span className="translate-bottom badge rounded-pill bg-danger">
                        {daysLeft}
                    </span>
                </div>
                <hr></hr>
              
            </div>

            <div className="p-8 space-y-6">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className={theme === 'dark' ? " font-semibold orange" : "font-bold text-primary"} >{userName} - {userEmail}</p>
                    </div>
                    <div >
                        <p className="text-[10px] uppercase tracking-widest  mb-1">Membership type - {typeOfMembership}</p>
                    </div>
                </div>

                {/* --- Styled Expiration & Grace Period Banner --- */}
                {expirationDate && (
                    <div className={`p-4 rounded-lg border-l-4 ${daysPast > 90 ? 'bg-red-500/10 border-red-500' : 'bg-blue-500/5 border-blue-500'}`}>
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-[10px] uppercase font-bold opacity-70">Expire Date: &nbsp;</span>
                            {/* Date highlighted in Orange */}
                            <span className="text-sm font-mono font-bold orange">
                                {new Date(expirationDate).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })}
                            </span>
                        </div>
                        
                        <div className="space-y-1">
                            {daysPast > 90 ? (
                                <div className="flex justify-between items-center">
                                    <span className="text-[10px] uppercase font-bold opacity-70">Status:</span>&nbsp;
                                    <span className="text-[10px] font-bold text-red-500 uppercase tracking-wider">90-Day Grace Period Ended - late fee has been added...</span>
                                </div>
                            ) : (
                                <>
                                    <div className="flex justify-between items-center">
                                        <span className="text-[10px] uppercase font-bold opacity-70">Grace Remaining:</span>&nbsp;
                                        <span className="text-xs font-bold text-blue-500 uppercase">
                                          <span className="blue">  {91 - daysPast} Days</span>
                                        </span>
                                    </div>
                                    <div className="text-[9px] text-gray-500 italic mt-1 text-right">
                                        A late fee of {formatter.format(lateFee)} will be added after the 90-day grace period.
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

                <div className=" flex justify-between items-center">
                    <span className="text-sm font-medium ">Membership Fee:</span>
                    <span className="text-3xl font-mono font-bold ">  {formatter.format(amount)}</span>
                </div>

                {/* Late Fee Display: Only shows if math confirms > 90 days */}
                {effectiveLateFee > 0 && (
                    <div className=" flex justify-between items-center animated fadeInDown">
                        <span className="text-sm font-medium ">Late Fee:</span>
                        <span className="text-3xl font-mono font-bold red">  {formatter.format(lateFee)}</span>
                    </div>
                )}

                <div className=" flex justify-between items-center"><strong>
                    <span className="text-sm font-medium ">Total:</span>
                    <span className="text-3xl font-mono font-bold ">   {formatter.format(finalTotal)}</span>
                </strong>
                </div>

                {error && (
                    <p className="text-red-500 text-xs text-center font-bold bg-red-500/10 py-2 rounded border border-red-500/20">
                        {error}
                    </p>
                )}
                <hr></hr>
                <button
                    onClick={handlePayment}
                    disabled={loading}
                    className="btn-info padding rounded border hoverX"
                >
                    {loading ? 'Redirecting to Stripe...' : 'Make Payment'}
                </button>
                &nbsp;&nbsp;
                <button onClick={onClose} className="white btn-dark padding rounded border hoverX">Close</button>
                <hr></hr>
                <p className="text-left text-[10px] blue uppercase tracking-widest animated fadeInRight">
                    <img
                        src={target}
                        alt="Member Renewal"
                        className=" hoverX "
                        style={{ 'height': '30px' }}
                    />  Transaction Processed by Stripe
                </p>
            </div>
        </div>
    );
};

export default QuickPayment;